import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import PartnerTeamsTable from "./PartnerTeamsTable";
import TeamModal from "./Modals/TeamModal";
import DeleteTeamModal from "./Modals/DeleteTeamModal";
import { getExpenseTags } from "../../services/TransactionService";

const PartnerTeamsSection = ({
  partnerId,
  authUser,
  userPartnerDetails,
  cardRef,
  mode = "full",
  onSeeAll,
  onAddExpenseTag,
}) => {
  const { data: expenseTagsData, isLoading: expenseTagsLoading } = useQuery({
    queryKey: ["expenseTags", partnerId, 1],
    queryFn: () => getExpenseTags(partnerId, 1),
    enabled: !!partnerId,
    staleTime: 5 * 60 * 1000,
  });
  const hasExpenseTags = (expenseTagsData?.data?.data?.length ?? 0) > 0;
  const expenseTagsKnown = !expenseTagsLoading;

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [editingTeam, setEditingTeam] = useState(null);
  const [deletingTeam, setDeletingTeam] = useState(null);

  const openAddModal = () => {
    setEditingTeam(null);
    setModalMode("add");
    setModalOpen(true);
  };

  const openEditModal = (team) => {
    setEditingTeam(team);
    setModalMode("edit");
    setModalOpen(true);
  };

  const openDeleteModal = (team) => {
    setDeletingTeam(team);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingTeam(null);
  };

  const closeDeleteModal = () => {
    setDeletingTeam(null);
  };

  return (
    <>
      <PartnerTeamsTable
        partnerId={partnerId}
        authUser={authUser}
        userPartnerDetails={userPartnerDetails}
        cardRef={cardRef}
        mode={mode}
        onSeeAll={onSeeAll}
        onAddTeam={openAddModal}
        onEditTeam={openEditModal}
        onDeleteTeam={openDeleteModal}
        hasExpenseTags={hasExpenseTags}
        expenseTagsKnown={expenseTagsKnown}
        onAddExpenseTag={onAddExpenseTag}
      />
      <TeamModal
        show={modalOpen}
        onHide={closeModal}
        mode={modalMode}
        team={editingTeam}
        partnerId={partnerId}
      />
      <DeleteTeamModal
        show={!!deletingTeam}
        onHide={closeDeleteModal}
        team={deletingTeam}
        partnerId={partnerId}
      />
    </>
  );
};

export default PartnerTeamsSection;
